import * as Yup from 'yup';
import FileHelper from '../../../../helpers/file';

export const ProfileEditAvatarFormValidationSchema = Yup.object().shape({
  Picture: Yup.object()
    .test(
      'fileRequired',
      'This field is required',
      value => value && value.image
    )
    .test('fileFormat', 'This type of file is not supported', value => {
      return (
        ['image/jpeg'].includes(value.image.type) ||
        ['image/png'].includes(value.image.type)
      );
    })
    .test('fileSize', 'The file is too big. Max file size is 2MB', value => {
      return value.image.size <= 2 * 1024 * 1024;
    })
    .test(
      'imageSize',
      'Please select an image bigger than 50 x 50',
      async value => {
        const size = await FileHelper.getImageSize(value.image);
        return !(size.width < 50 && size.height < 50);
      }
    )
    .test(
      'imageRatio',
      'The aspect ratio of your image is currently not supported',
      async value => {
        const size = await FileHelper.getImageSize(value.image);
        const ration = size.width / size.height;
        return ration >= 0.2 && ration <= 5;
      }
    ),
});
